module.exports = __webpack_public_path__ + "static/media/bg-mob-2.5fd42e7e.jpg";